import { React, ts } from '_core';

import Chart from './chart';
import { Params } from './types';

type PortfolioRiskSummaryProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  context?: ts.types.portfolio.PortfolioAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'portfolio_risk_summary', string>;
  params: Params;
  setParams: (_p: Params) => void;
  goFullScreen?: (_b: string) => void;
  fullScreen?: boolean;

  queryParams?: { initial?: string };
};

const PortfolioRiskSummary = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  params,
  setParams,
  widgetPaths,
  fullScreen,
  goFullScreen,
  queryParams,
  context,
}: PortfolioRiskSummaryProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      params={params}
      setParams={setParams}
      loadWidgetData={loadWidgetData}
      summary={widgetPaths['portfolio_risk_summary']}
      fullScreen={fullScreen}
      queryParams={queryParams}
      goFullScreen={goFullScreen}
      context={context}
    />
  );
};

export default PortfolioRiskSummary;
